import styled from 'styled-components';

export const TitleContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
`;

export const TitleImage = styled.img`
	width: 24px;
	height: 24px;
`;

export const Wrapper = styled.div`
	min-width: 400px;

	@media (max-width: 500px) {
		min-width: auto;
	}
`;

export const Message = styled.div`
	color: ${({ theme }) => theme.colors.text.body};
	font-size: 16px;
	line-height: 1.6;
	margin-bottom: 24px;

	strong {
		color: ${({ theme }) => theme.colors.text.title};
		font-weight: 600;
	}
`;

export const Footer = styled.div`
	display: flex;
	justify-content: flex-end;
	gap: 12px;

	button {
		min-width: 120px;
	}
`;

